<script setup lang="ts">
export interface AppSlideTransitionProps {
  direction: 'left' | 'right' | 'top' | 'bottom' | 'disabled';
}

const props = defineProps<AppSlideTransitionProps>();
</script>

<template>
  <Transition :name="`slide-${props.direction}`">
    <slot />
  </Transition>
</template>

<style scoped lang="scss">
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active,
.slide-right-enter-active,
.slide-right-leave-active,
.slide-top-enter-active,
.slide-top-leave-active,
.slide-bottom-enter-active,
.slide-bottom-leave-active {
  transition: transform var(--transition-time-medium) ease;
}
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
}

.slide-top-enter-from,
.slide-top-leave-to {
  transform: translateY(-100%);
}

.slide-bottom-enter-from,
.slide-bottom-leave-to {
  transform: translateY(100%);
}
</style>
